import React from 'react';

import {
  DELETE_LANGUAGE_MODAL_TEXT,
  DELETE_LANGUAGE_MODAL_TITLE
} from 'views/Localization/constants/constants';

import DialogModal from 'components/DialogModal/DialogModal';

import { DeleteLanguageModalProps } from './DeleteLanguagesModal.types';

const DeleteLanguageModal = ({
  isOpen,
  setIsDeleteModalOpen,
  handleDeleteLanguage,
  handleSelectedLanguage
}: DeleteLanguageModalProps) => {
  return (
    <DialogModal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          setIsDeleteModalOpen(false);
          handleSelectedLanguage(null);
        }
      }}
      title={DELETE_LANGUAGE_MODAL_TITLE}
      customDescriptionContent={DELETE_LANGUAGE_MODAL_TEXT}
      modalActions={{
        onConfirm: { 
          label: 'Delete', 
          action: handleDeleteLanguage 
        },
        onClose: {
          label: 'Cancel',
          action: () => {
            setIsDeleteModalOpen(false);
            handleSelectedLanguage(null);
          },
          variant: 'link'
        }
      }}
    />
  );
};

export default DeleteLanguageModal;
